<template>
  <div id="nova">
    <div>
      <MainHeader />
      <div
        class="hidden lg:block lg:fixed left-0 bottom-0 top-0 w-72 py-4 bg-[#FAFAFA]"
      >
        <div class="bg-[#FAFAFA] flex items-center">
          <Link
            :href="$url('/')"
            class="text-gray-900 hover:text-gray-500 active:text-gray-900 dark:text-gray-400 dark:hover:text-gray-300 dark:active:text-gray-500 h-[60px] rounded-lg ml-2 focus:ring focus:ring-inset focus:outline-none ring-primary-200 dark:ring-gray-600 px-4 w-full flex items-center"
            :aria-label="appName"
          >
            <AppLogo class="h-[60px] w-auto" />
          </Link>
        </div>
        <MainMenu class="px-3 pt-8" data-screen="desktop" />
      </div>
    </div> 

    <!-- Content -->
    <div data-testid="content">

      <div class="p-4 md:py-8 md:px-12 lg:ml-72 space-y-8 content-height bg-white rounded-bl-[50px]">
        <Breadcrumbs v-if="breadcrumbsEnabled" />

        <FadeTransition>
          <slot />
        </FadeTransition>

        <Footer />
      </div>
    </div>
  </div>
</template>

<script>
import MainHeader from '@/layouts/MainHeader'
import Footer from '@/layouts/Footer'
import {InteractsWithResourceInformation} from '@/mixins'

export default {

  mixins: [
    InteractsWithResourceInformation
  ],
  components: {
    MainHeader,
    Footer,
  },

  mounted() {
    console.log(this.resourceName)
    Nova.$on('error', this.handleError)
    Nova.$on('token-expired', this.handleTokenExpired)
  },

  beforeUnmount() {
    Nova.$off('error', this.handleError)
    Nova.$off('token-expired', this.handleTokenExpired)
  },

  methods: {
    handleError(message) {
      Nova.error(message)
    },

    handleTokenExpired() {
      // @TODO require Nova._createToast() to support action with link.
      Nova.$toasted.show(this.__('Sorry, your session has expired.'), {
        action: {
          onClick: () => Nova.redirectToLogin(),
          text: this.__('Reload'),
        },
        duration: null,
        type: 'error',
      })

      setTimeout(() => {
        Nova.redirectToLogin()
      }, 5000)
    },
  },

  computed: {
    breadcrumbsEnabled() {
      return Nova.config('breadcrumbsEnabled')
    },
  },
}
</script>
